const listingSource = {
  USER_ENTRY: 1,
  SCRAPER: 2,
  INSTAGRAM: 3,
};

module.exports = listingSource;
